<div class="eidos-filter-wrapper eidos-sliderrange-filter-wrapper">
  <p class="eidos-filter-label eidos-sliderrange-filter-label" *ngIf="config.label">{{ config.label }}</p>

  <eidos-input-switch [(value)]="value" (valueChange)="config.onValueChange"
    [disabled]="!!config.disabled" [placeholder]="config.placeholder"
    (onFocusIn)="(!!config.onFocusIn && config.onFocusIn())"
    (onFocusOut)="(!!config.onFocusOut && config.onFocusOut())"></eidos-input-switch>
</div>